if (!customElements.get('product-discount-banner')) {
  class ProductDiscountBanner extends HTMLElement {
    connectedCallback() {
      this.applyButton = this.querySelector('[data-apply-discount]');
      this.applyLabel = this.querySelector('[data-apply-label]');
      this.closeButton = this.querySelector('[data-close-discount]');
      this.status = this.querySelector('[data-discount-status]');
      this.applyButton?.addEventListener('click', this.showApplyingState);
      this.closeButton?.addEventListener('click', this.dismissOffer);
      this.showAppliedState();

      try {
        if (sessionStorage.getItem(this.dismissStorageKey) === 'true' && !this.classList.contains('is-applied')) {
          this.hidden = true;
        }
      } catch (error) {
        // The close button still works for the current page without storage.
      }
    }

    disconnectedCallback() {
      this.applyButton?.removeEventListener('click', this.showApplyingState);
      this.closeButton?.removeEventListener('click', this.dismissOffer);
    }

    dismissOffer = () => {
      try {
        sessionStorage.setItem(this.dismissStorageKey, 'true');
      } catch (error) {
        // Hiding the current element does not require storage.
      }
      this.hidden = true;
    };

    showApplyingState = () => {
      try {
        sessionStorage.setItem(this.storageKey, 'pending');
      } catch (error) {
        // The redirect query parameter remains available as a fallback.
      }
      this.applyLabel.textContent = 'Applying…';
      this.applyButton.setAttribute('aria-disabled', 'true');
    };

    showAppliedState = () => {
      const url = new URL(window.location.href);
      const queryConfirmsDiscount = url.searchParams.get('discount_applied') === this.dataset.discountCode;
      let sessionConfirmsDiscount = false;

      try {
        sessionConfirmsDiscount = sessionStorage.getItem(this.storageKey) === 'pending';
      } catch (error) {
        // Storage can be unavailable in strict privacy modes.
      }

      if (!queryConfirmsDiscount && !sessionConfirmsDiscount) return;

      this.status.hidden = false;
      this.classList.add('is-applied');
      this.applyLabel.textContent = 'Applied ✓';
      this.applyButton.setAttribute('aria-disabled', 'true');
      this.applyButton.addEventListener('click', (event) => event.preventDefault(), { once: true });

      try {
        sessionStorage.removeItem(this.storageKey);
      } catch (error) {
        // No cleanup is needed when storage is unavailable.
      }

      if (queryConfirmsDiscount) {
        url.searchParams.delete('discount_applied');
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      }
    };

    get storageKey() {
      return `gleamore-discount-${this.dataset.discountCode}`;
    }

    get dismissStorageKey() {
      return 'gleamore-first-order-offer-dismissed';
    }
  }

  customElements.define('product-discount-banner', ProductDiscountBanner);
}
